import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';
import { TestPublicGate } from './../../../../../backend/src/core/test/test.public.gate';

@Injectable({
  providedIn: 'root',
})
export class TestService {
  constructor(private lambdaService: LambdaService) {}

  ping() {
    this.lambdaService
      .run$(ResourceName.test, TestPublicGate.actions.ping, undefined, { isPublicUrl: true })
      .pipe(take(1))
      .subscribe((data) => {
        console.log('----- finished ping:', data);
      });
  }

  fixBug() {
    console.log('----- fixBug');
    this.lambdaService
      .run$(ResourceName.test, TestPublicGate.actions.fixBug, undefined, { isPublicUrl: true })
      .pipe(take(1))
      .subscribe((data) => {
        console.log('----- finished ping:', data);
      });
  }
}
